import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routes } from "routes";
import { STEP_SESSION_STORAGE_KEY } from "hooks";
import notFoundImage from "assets/404.png";

import { ButtonContainer, Container, StyledImage } from "./NotFound.css";


export const NotFound = () => {
  const navigate = useNavigate();

  const onBackHandler = () => {
    sessionStorage.setItem(STEP_SESSION_STORAGE_KEY, "1");
    navigate(routes.form);
  };
  return (
    <Container>
      <StyledImage alt="not found page" src={notFoundImage}/>

      <ButtonContainer>
        <Button onClick={onBackHandler} fullWidth variant="contained">
          back home
        </Button>
      </ButtonContainer>
    </Container>
  );
};
